import React from "react";
import { EventEntry } from "../../../models";
import SubSectionCard from "./SubSectionCard";
import { getEntrySubCardHeaderLines } from "./entrySubCardUtils";

export interface EntrySubSectionCardProps {
    entry: EventEntry;
    /** 1-based entry number shown in the header (e.g. 1 → "Entry 1"). */
    entryNumber: number;
    children?: React.ReactNode;
    collapsedHeaderTrailing?: React.ReactNode;
    defaultExpanded?: boolean;
    collapsedContent?: React.ReactNode;
    stallCount?: number;
    /** Optional remount key for accordion focus (e.g. Waivers deep-link). */
    remountKey?: string;
    padding?: string;
    showChevron?: boolean | "expandedOnly";
    leadingEmoji?: string;
    className?: string;
}

/**
 * Standard entry subcard: Entry # / horse / rider header on `SubSectionCard`.
 * Used in Stabling + Extras, Waivers, and Entry Summary.
 */
const EntrySubSectionCard: React.FC<EntrySubSectionCardProps> = ({
    entry,
    entryNumber,
    children,
    collapsedHeaderTrailing,
    defaultExpanded = false,
    collapsedContent,
    stallCount,
    remountKey,
    padding = "px-0 py-1",
    showChevron = "expandedOnly",
    leadingEmoji = "🐴",
    className = "mb-2",
}) => {
    const { horseLine, ridersLine } = getEntrySubCardHeaderLines(entry);

    return (
        <div className={className}>
            <SubSectionCard
                key={remountKey}
                title={`Entry ${entryNumber}`}
                titleSecondaryLine={horseLine}
                titleTertiaryLine={ridersLine}
                leadingEmoji={leadingEmoji}
                padding={padding}
                defaultExpanded={defaultExpanded}
                allowWrappedTitle={true}
                showChevron={showChevron}
                collapsedHeaderTrailing={collapsedHeaderTrailing}
                collapsedContent={collapsedContent}
                stallCount={stallCount}>
                {children}
            </SubSectionCard>
        </div>
    );
};

export default EntrySubSectionCard;
